import * as congNoConstant from './constants'

export const congNoKhoXuatRequest = function congNoKhoXuatRequest (formData) {  
  return {
    type: congNoConstant.CONG_NO_KHOXUAT_REQUESTING,
    payload: formData
  }
}

export const congNoKhoXuatSuccess = function congNoKhoXuatSuccess (data) {  
  return {
    type: congNoConstant.CONG_NO_KHOXUAT_SUCCESS,
    data
  }
}

export const congNoKhoXuatError = function congNoKhoXuatError (error) {  
  return {
    type: congNoConstant.CONG_NO_KHOXUAT_ERROR,
    error
  }
}
export const congNoListRequest = function congNoListRequest (formData) {  
  return {
    type: congNoConstant.CONG_NO_LIST_REQUESTING,
    formData
  }
}

export const congNoListSuccess = function congNoListSuccess (data) {  
  return {
    type: congNoConstant.CONG_NO_LIST_SUCCESS,
    data
  }
}

export const congNoListError = function congNoListError (error) {  
  return {
    type: congNoConstant.CONG_NO_LIST_ERROR,
    error
  }
}

export const reportExportXlsRequest = function reportExportXlsRequest(formData) {
  return {
    type: congNoConstant.CONG_NO_EXPORT_XLS_REQUESTING,
    formData
  }
}

export const reportExportXlsSuccess = function reportExportXlsSuccess(data) {
  return {
    type: congNoConstant.CONG_NO_EXPORT_XLS_SUCCESS,
    data
  }
}

export const reportExportXlsError = function reportExportXlsError(error) {
  return {
    type: congNoConstant.CONG_NO_EXPORT_XLS_ERROR,
    error
  }
}
export const congNoKHListRequest = function congNoKHListRequest (formData) {  
  return {
    type: congNoConstant.CONG_NO_KH_LIST_REQUESTING,
    formData
  }
}

export const congNoKHListSuccess = function congNoKHListSuccess (data) {  
  return {
    type: congNoConstant.CONG_NO_KH_LIST_SUCCESS,
    data
  }
}

export const congNoKHListError = function congNoKHListError (error) {  
  return {
    type: congNoConstant.CONG_NO_KH_LIST_ERROR,
    error
  }
}
export const congNoKHExportXlsRequest = function congNoKHExportXlsRequest(formData) {
  return {
    type: congNoConstant.CONG_NO_KH_EXPORT_XLS_REQUESTING,
    formData
  }
}

export const congNoKHExportXlsSuccess = function congNoKHExportXlsSuccess(data) {
  return {
    type: congNoConstant.CONG_NO_KH_EXPORT_XLS_SUCCESS,
    data
  }
}

export const congNoKHExportXlsError = function congNoKHExportXlsError(error) {
  return {
    type: congNoConstant.CONG_NO_KH_EXPORT_XLS_ERROR,
    error
  }
}

export const congNoHDListRequest = function congNoHDListRequest (formData) {  
  return {
    type: congNoConstant.CONG_NO_HD_LIST_REQUESTING,
    formData
  }
}

export const congNoHDListSuccess = function congNoHDListSuccess (data) {  
  return {
    type: congNoConstant.CONG_NO_HD_LIST_SUCCESS,
    data
  }
}

export const congNoHDListError = function congNoHDListError (error) {  
  return {
    type: congNoConstant.CONG_NO_HD_LIST_ERROR,
    error
  }
}
export const congNoHDExportXlsRequest = function congNoHDExportXlsRequest(formData) {
  return {
    type: congNoConstant.CONG_NO_HD_EXPORT_XLS_REQUESTING,
    formData
  }
}

export const congNoHDExportXlsSuccess = function congNoHDExportXlsSuccess(data) {
  return {
    type: congNoConstant.CONG_NO_HD_EXPORT_XLS_SUCCESS,
    data
  }
}

export const congNoHDExportXlsError = function congNoHDExportXlsError(error) {
  return {
    type: congNoConstant.CONG_NO_HD_EXPORT_XLS_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/CongNo/actions.js